import { QueryKey, UseQueryOptions, useQuery } from "@tanstack/react-query";
import { PRODUCT_ENDPOINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ResponseDTO } from "interface";
import { ProductType } from "pages/catalog/AddProduct/type";

type QueryType = { page: number; search: string };
type OptionsType = UseQueryOptions<
  ResponseDTO<ProductType[]>,
  QueryType,
  ResponseDTO<ProductType[]>
>;

const listFn = async (query: QueryKey): Promise<ResponseDTO<ProductType[]>> => {
  const [{ page, search } = { page: 1, search: "" }] = query as QueryType[];

  const filters =
    (search ?? "").length > 0
      ? [
        {
          propertyName: "name",
          operation: "contains",
          value: search,
        },
      ]
      : [];

  const res = await instance.post(PRODUCT_ENDPOINTS.list, {
    ...{
      page: page,
      pageSize: 10,
      inputParams: {
        filters: filters,
        sort: {
          propertyName: "id",
          ascending: false,
        },
      },
    },
  });

  return res.data;
};

export const useGetProducts = (options?: OptionsType) =>
  useQuery({
    queryKey: [PRODUCT_ENDPOINTS.list],
    queryFn: ({ queryKey }) => listFn(queryKey),
    ...options,
  });
